import React from 'react';

export function FailedDeliveryIcon(): JSX.Element {
  return (
    <svg fill='none' height='40' viewBox='0 0 41 40' width='41' xmlns='http://www.w3.org/2000/svg'>
      <rect fill='#EADAF2' fillOpacity='0.5' height='40' rx='8' width='40' x='0.5' />
      <path
        clipRule='evenodd'
        d='M20.333 12.1666C16.0988 12.1666 12.6663 15.5991 12.6663 19.8333C12.6663 24.0675 16.0988 27.5 20.333 27.5C24.5672 27.5 27.9997 24.0675 27.9997 19.8333C27.9997 15.5991 24.5672 12.1666 20.333 12.1666ZM11.333 19.8333C11.333 14.8628 15.3624 10.8333 20.333 10.8333C25.3036 10.8333 29.333 14.8628 29.333 19.8333C29.333 24.8039 25.3036 28.8333 20.333 28.8333C15.3624 28.8333 11.333 24.8039 11.333 19.8333Z'
        fill='#9050FF'
        fillRule='evenodd'
      />
      <path
        clipRule='evenodd'
        d='M13.9699 13.4702C14.2303 13.2099 14.6524 13.2099 14.9127 13.4702L26.6961 25.2536C26.9564 25.5139 26.9564 25.936 26.6961 26.1964C26.4357 26.4567 26.0136 26.4567 25.7533 26.1964L13.9699 14.4131C13.7096 14.1527 13.7096 13.7306 13.9699 13.4702Z'
        fill='#9050FF'
        fillRule='evenodd'
      />
    </svg>
  );
}
